import { render, staticRenderFns } from "./CompareView.vue?vue&type=template&id=f5f58152&scoped=true&"
import script from "./CompareView.vue?vue&type=script&lang=ts&"
export * from "./CompareView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f58152",
  null
  
)

export default component.exports